module.exports = __webpack_public_path__ + "static/media/mars_full_sm.c1ec120a.png";